import CoreBase from '../../../../services/engines/CoreBase';
import appendHandler from './handlers/AppendHandler';
import updateHandler from './handlers/UpdateHandler';
import updateMealHandler from './handlers/UpdateMealHandler';
import updateEmsHandler from './handlers/UpdateEmsHandler';
import updateBodyHandler from './handlers/UpdateBodyHandler';
import removeHandler from './handlers/RemoveHandler';
import updateLayoutHandler from './handlers/UpdateLayoutHandler';
import openUrlHandler from './handlers/OpenUrlHandler';
import searchHandler from './handlers/SearchHandler';
import contextMenuHandler from './handlers/ContextMenuHandler';
import dropHandler from './handlers/DropHandler';

class MessageRouter extends CoreBase {
    _name = 'MessageRouter';

    _listener = null;

    /**
     * Registers the message listener for the given iframe.
     * @param {HTMLIFrameElement} iframe
     * @param {object} entry
     * @param {string} tid
     * @param {Function} onRebuild
     */
    register(iframe, entry, tid, onRebuild) {
        this.unregister();

        const handlers = {
            'jerny:append':       (e) => appendHandler.handle(e, iframe, entry),
            'jerny:update':       (e) => updateHandler.handle(e, iframe, entry),
            'jerny:updatemeal':   (e) => updateMealHandler.handle(e, iframe, entry),
            'jerny:updateems':    (e) => updateEmsHandler.handle(e, iframe, entry),
            'jerny:updatebody':   (e) => updateBodyHandler.handle(e, iframe, entry),
            'jerny:remove':       (e) => removeHandler.handle(e, iframe, entry),
            'jerny:updatelayout': (e) => updateLayoutHandler.handle(e, iframe, tid),
            'jerny:openurl':      (e) => openUrlHandler.handle(e),
            'jerny:search':       (e) => searchHandler.handle(e),
            'jerny:contextmenu':  (e) => contextMenuHandler.handle(e, iframe),
            'jerny:drop':         (e) => dropHandler.handle(e, iframe),
            'jerny:rebuild':      ()  => onRebuild(),
            'jerny:clipboard':    (e) => navigator.clipboard.writeText(e.data.text ?? '').catch(() => {}),
        };

        this._listener = (e) => {
            const handler = handlers[e.data?.type];
            if (handler) handler(e);
        };

        window.addEventListener('message', this._listener);
    }

    /**
     * Unregisters the current message listener.
     */
    unregister() {
        if (!this._listener) return;
        window.removeEventListener('message', this._listener);
        this._listener = null;
    }
}

const messageRouter = new MessageRouter();
export default messageRouter;
